module.exports = __webpack_public_path__ + "static/media/email.0086793c.png";


//////////////////
// WEBPACK FOOTER
// ./src/landing/images/email.png
// module id = 342
// module chunks = 0